<div class="read-speaker rs_skip rsbtn rs_preserve">
    <a
        [hidden]="playing"
        rel="nofollow"
        class="rsbtn_play read-speaker__button"
        accesskey="L"
        title="Laat de tekst voorlezen met ReadSpeaker"
        href="//app-eu.readspeaker.com/cgi-bin/rsent?customerid=5797&lang=en_uk&voice=Alice&speed=75&readid={{
            readId
        }}&url="
        (click)="startPlaying()"
    >
        <span class="icon">
            <i class="fas fa-volume-up"></i>
        </span>
    </a>

    @if (playing) {
    <a
        (click)="stopPlaying()"
        class="read-speaker__button read-speaker__button--playing"
    >
        <span class="icon">
            <i class="fas fa-volume-up"></i>
        </span>
    </a>
    }
</div>
